/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Pasteurization } from "./modelPasteurization";

class ControllerPasteurization extends ControllerModel {
  constructor() {
    super("ControllerPasteurization");
    
    this.setNewNode = (callback) => {
      let vasteurization = new Pasteurization();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new Pasteurization();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new Pasteurization();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new Pasteurization();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerPasteurization };
